import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { Observable } from "rxjs";

export interface ConfirmDialogData {
  title: string;
  prompt: string;
}

@Component({
  selector: "confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
})
export class ConfirmDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }

  static showDialog(
    dialog: MatDialog,
    title: string,
    prompt: string
  ): Observable<any> {
    var params: ConfirmDialogData = {
      title: title,
      prompt: prompt,
    };

    var dialogRef = dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    return dialogRef.afterClosed();
  }
}
